import React, { useEffect } from 'react';

import { connect } from 'react-redux';
import { Link } from 'react-router';
import { actions } from '../../../../dashboard/redux/dashboardActions';
import { FormattedDate } from 'react-intl';
import { get } from 'lodash';
import './Reminders.scss';
import ReactMarkdown from 'react-markdown';
import { bindActionCreators } from 'redux';

const Reminders = ({ dashboard, actions }) => {
  useEffect(
    () => {
      actions.fetchReminders();
    },
    [actions],
  );

  const handleClear = (note) => (e) => {
    e.preventDefault();
    actions.clearReminder(note.id);
    actions.fetchStats();
  };

  const reminders = get(dashboard.reminders, 'data', []);
  return (
    <div>
      <table className="table reminders-list">
        <tbody>
          {!!reminders.length ? (
            reminders.map((note, index) => {
              return (
                <tr key={index}>
                  <td className="reminder-date">
                    <FormattedDate value={note.attributes.reminder_at} />
                  </td>
                  <td>
                    <ReactMarkdown source={note.attributes.content} />
                  </td>
                  <td className="reminder-action">
                    {note.attributes.forward_url && (
                      <span>
                        <Link to={note.attributes.forward_url} onlyActiveOnIndex={false}>
                          View
                        </Link>
                      </span>
                    )}
                    {note.attributes.forward_url && <span> | </span>}
                    <a href="#" onClick={handleClear(note)}>
                      Clear
                    </a>
                  </td>
                </tr>
              );
            })
          ) : (
            <tr key={1}>
              <td colSpan="2">You have no reminders</td>
              <td />
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

export default connect(
  (state) => ({
    dashboard: state.dashboard,
  }),
  (dispatch) => ({
    actions: bindActionCreators(actions, dispatch),
  }),
)(Reminders);
